import React, { useEffect, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import {searchsiteStoreProductList } from "../../services/centralStore/centralStore"
import UpdateTable from "../../components/Common/UpdatedTable"
// import UpdateTable from "../../../components/Common/UpdatedTable"
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
// import action from "../../../assets/icons/action.svg"
// import { searchCentralStoreProductList } from "../../../services/centralStore/centralStore"
import ProductFilter from "./filter"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import NumberFormat from "../../utils/numberFormat"

const SiteProductList = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Product List${companyname ? ` | ${companyname}` : ''}`;

  const [page, setPage] = useState("")
  const [productList, setProductList] = useState("")
  const [count, setCount] = useState(0)
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")

  useEffect(() => {
    const fetchData = async () => {
      const response = await searchsiteStoreProductList({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${page ? `&page=${page}` : "" }&type=site&project_id=5`,
      })
      setProductList(response)
    }
    fetchData()
  }, [count, status, search, page])

  const columns = [
    {
      label: "Product Code",
      renderCell: item => item?.product_id?.product_code,
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => <div className="text-end pe-5">{NumberFormat((Number(item?.quantity)))}</div>,
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content tnt-scope">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Central Store"
              breadcrumbObject={[
                { title: "Central Store", link: "/central-store" },
                { title: "Product List", link: "/central-store/product-list" },
              ]}
            />
          </div>
          <Card className="me-2 px-2 pb-2 main-dashboard-bg">

            <ProductFilter
              handleSearchChange={handleSearchChange}
              placeholder="Search"
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {productList?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={productList?.data?.data}
                    paginate={productList?.data}
                    CurrentPage={page}
                    columns={columns}
                    handlePagination={handlePaginate}
                    tableWidth="50% 50%"
                    mobileWidth="50% 50%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}
export default SiteProductList
